import React from 'react'
import Popup from 'react-popup'
import intl from 'react-intl-universal'
import Lightbox from 'react-simple-lightbox'
import Autosuggest from 'react-autosuggest'
import { connect } from 'react-redux'
import { b64EncodeUnicode } from '../utils/Tools'
import { ReactComponent as Check } from '../assets/check.svg'
import printBundle from './BundleItemList'
import BundleItemListExtended from './BundleItemListExtended';
import { updateCounter } from '../utils/CountersUtils'
import { isScanRequiredForLine, isMouseEvent, showScanRequiredPopup, setManualConfirmation, isElementScanRequired } from '../utils/ScanRequirementUtils'

const mapStateToProps = state => ({
  product_confirmation_method: state.config.product_confirmation_method,
  require_scan_for_products_with_barcode: state.config.require_scan_for_products_with_barcode || false,
  verify_qty: state.config.verify_qty,
  stock_location: state.config.stock_location,
  group_treshold: state.config.group_treshold ? parseInt(state.config.group_treshold) : false,
  bundle_select: state.config.bundle_select || false,
  show_grouped_counter: state.config.show_grouped_counter || false,
  show_grouped_counter_check_all: state.config.show_grouped_counter_check_all || false,
  show_barcode_in_packing_zone: state.config.show_barcode_in_packing_zone || false,
  show_line_option_in_packing_zone: state.config.show_line_option_in_packing_zone || false,
  order: state.pack.order,
  auto_check_all_products: state.config.auto_check_all_products,
  scan_bundle_element_as_single_qty: state.config.scan_bundle_element_as_single_qty,
  bundleViewExtended: state.config.packing_zone_detailed_bundles_elements_view || false
})

class ProductListItemComponent extends React.Component {
  constructor(props) {
    super(props)
    const { parent, product } = this.props
    const defaultLot = (product && product.lots && product.lots.find(lot => lot[2] === true)) || [false, ''];
    this.state = {
      suggestions: [],
      selectedLot: defaultLot,
      lots: props.product.lots || [],
      substitutes: parent.getOrderSubstitutes(product.line_id),
      groupCounter: 0,
      currentIndex: 0,
    }
  }

  getLots = (value) => {
    const inputValue = value.trim().toLowerCase()
    const {lots} = this.props.product
    return inputValue.length === 0 ? lots : lots.filter(lot =>
      lot[1].toLowerCase().includes(inputValue)
    )
  }

  onLotsFetchRequested = ({ value }) => {
    this.setState({
      lots: this.getLots(value)
    })
  }

  handleLotChange = (event, { newValue }) => {
    this.setState({
      selectedLot: this.props.product.lots.find(lot => lot[0] === newValue) || [false, newValue]
    })
  }

  setSubstitutes = (id, val) => {
    const { substitutes } = this.state
    this.setState({
      substitutes: {
        ...substitutes,
        [id]: val
      }
    })
  }

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  confirmSubstitutes = () => {
    const { substitutes } = this.state
    const { parent, product, qty } = this.props
    const { auto_check_all_products } = this.props;
    const wantedQty = typeof product.line_qty !== 'undefined' ? product.line_qty : qty
    const sumVals = Object.values(substitutes || {}).reduce((a, b) => parseInt(a || 0) + parseInt(b || 0), 0)
    if(sumVals !== wantedQty){
      document.querySelector('.total-substitutes').classList.add('shake')
      setTimeout(() => document.querySelector('.total-substitutes').classList.remove('shake'), 500)
      return false
    }
    parent.setOrderSubstitutes(product.line_id, substitutes)
    if (auto_check_all_products) {
      const checkboxes = document.querySelectorAll('.product_checkbox .checkbox');

      async function simulateMouseClick(el) {
        let opts = { view: window, bubbles: true, cancelable: true };
        el.dispatchEvent(new MouseEvent("mousedown", opts));
        el.dispatchEvent(new MouseEvent("mouseup", opts));
        el.dispatchEvent(new MouseEvent("click", opts));
      }

      for (const checkbox of checkboxes) {
        if (isElementScanRequired(checkbox.closest('.produkt.ramka'))) continue;
        simulateMouseClick(checkbox);
        break;
      }
    }
    return true
  }

  resetSubstitutes = () => {
    const { parent, product } = this.props
    this.setState({
      substitutes: parent.getOrderSubstitutes(product.line_id)
    })
  }

  incrementGroupCounter = (event) => {
    const { parent, product } = this.props;
    const { groupCounter } = this.state;
    const $produkt = event.currentTarget.closest('.produkt.ramka');

    if (isMouseEvent(event)) {
      if (isScanRequiredForLine(this.props, product)) {
        showScanRequiredPopup();
        return;
      }
      setManualConfirmation($produkt, true);
    }
    const cnt = parseInt($produkt.getAttribute('data-prods'), 10);
    const $checkbox = $produkt.querySelector('.mainCheckbox');

    if (groupCounter < cnt) {
      this.setState(
        prevState => ({ groupCounter: prevState.groupCounter + 1 }),
        () => {
          this.updateCountersFromGroupCounter();

          if (this.state.groupCounter === cnt) {
            $checkbox.classList.add('checked');
            if ($produkt.querySelector('.bundleItemList')) {
              this.updateBundleCheckboxesAndCounters($produkt, true);
            }
            parent.toggleConfirmButton();
          }
        }
      );
    }
  }

  modIncrementGroupCounter = (event) => {
    const { parent, product } = this.props
    const { groupCounter } = this.state
    const $produkt = event.currentTarget.closest('.produkt.ramka')

    if (isMouseEvent(event)) {
      if (isScanRequiredForLine(this.props, product)) {
        showScanRequiredPopup();
        return;
      }
      setManualConfirmation($produkt, !event.currentTarget.classList.contains('checked'));
    }
    const cnt = parseInt($produkt.getAttribute('data-prods'))
    const $checkboxes = $produkt.querySelectorAll('.mainCheckbox')
    const $productCheckboxColumn = $produkt.querySelector('.product_checkbox')
    let $checkbox = event.currentTarget

    const isChecked = $checkbox.classList.contains('checked');

    if (isChecked) {
      $checkbox.classList.remove('checked');
      $checkboxes.forEach($cb => $cb.classList.remove('checked'));

      $checkbox.setAttribute('data-label', intl.get('Oznacz wszystko'));
      $productCheckboxColumn.classList.remove('locked')

      const $bundleWrapper = $produkt.querySelector('.bundleWrapper');
      if ($bundleWrapper) {
        $bundleWrapper.classList.remove('locked');
        const $bundleCheckboxes = $bundleWrapper.querySelectorAll('.checkbox-wrapper .checkbox');
        $bundleCheckboxes.forEach($cb => $cb.classList.remove('checked'));

        const $counters = $bundleWrapper.querySelectorAll('.counter');
        if ($counters.length) {
          $counters.forEach($counter => {
            updateCounter($counter, 0);
          });
        }
      }

      parent.toggleConfirmButton();
      this.setState({ groupCounter: 0 });
      return;
    }

    Popup.create({
      content: intl.get('Czy na pewno spakowałeś X pozycji tego SKU?', { cnt: cnt }),
      buttons: {
        right: [
          {
            text: intl.get('Tak'),
            key: 'enter',
            action: () => {
              Popup.close();

              $checkbox.classList.add('checked');
              $checkboxes.forEach($cb => {
                if (!$cb.classList.contains('checked')) {
                  $cb.classList.add('checked');
                }
              });
              $productCheckboxColumn.classList.add('locked')
              $checkbox.setAttribute('data-label', intl.get('Anuluj zaznaczenie'));

              parent.toggleConfirmButton();

              if (groupCounter < cnt) {
                this.setState({ groupCounter: cnt });
              }

              const $bundleWrapper = $produkt.querySelector('.bundleWrapper');
              if ($bundleWrapper) {
                $bundleWrapper.classList.add('locked');
                const $bundleCheckboxes = $bundleWrapper.querySelectorAll('.checkbox-wrapper .checkbox');
                $bundleCheckboxes.forEach($cb => $cb.classList.add('checked'));


                const $counters = $bundleWrapper.querySelectorAll('.counter');
                if ($counters.length) {
                  $counters.forEach($counter => {
                    const fullQty = parseFloat($counter.dataset.qtyUom) || 0;
                    updateCounter($counter, fullQty);
                  });
                }
              }
            }
          },
          {
            text: intl.get('Nie'),
            className: 'cancel-button',
            action: () => {
              Popup.close();
            }
          }
        ]
      }
    })
  }

  checkboxClick = (event, prodsCount) => {
    const {
      product_confirmation_method,
      group_treshold,
      show_grouped_counter,
      product,
      parent,
      bundle_select,
      productTracking,
      verify_qty,
      isPackagingBox
    } = this.props;
    const { selectedLot, groupCounter } = this.state;

    if (productTracking && selectedLot[1] === '') {
      return;
    }

    const bundle_qty = event.currentTarget.dataset.bundleItemQty;

    // Blokada kliknięć w trybie 'scan'
    if (product_confirmation_method === 'scan' && event.isTrusted) {
      console.log('Klik myszką zablokowany w trybie scan !!!');
      return;
    }

    if (
      product.is_bundle &&
      event.currentTarget.classList.contains('mainCheckbox') &&
      !bundle_select
    ) {
      console.log('bundle_select is disabled');
      return;
    }

    if (isMouseEvent(event)) {
      if (isScanRequiredForLine(this.props, product)) {
        showScanRequiredPopup();
        return;
      }
      setManualConfirmation(
        event.currentTarget.closest('.produkt.ramka'),
        !event.currentTarget.classList.contains('checked')
      );
    }

    let $checkbox = event.currentTarget;
    let $produkt = event.currentTarget.closest('.produkt.ramka');
    const bundleWrapper = $produkt.querySelector('.bundleWrapper');
    const groupedMarkAll = $produkt.querySelector('.grouped__mark-all');

    if (bundleWrapper) {
      console.log('bundle wrapper blocked -- temporary disable');
      // bundleWrapper.classList.add('locked');
    }
    if (groupedMarkAll) {
      console.log('grouped mark all blocked -- temporary disable');
      // groupedMarkAll.classList.add('locked');
    }

    let cnt = parseInt($produkt.dataset.prods);
    if (typeof prodsCount === 'undefined') {
      prodsCount = cnt;
    }

    if (typeof bundle_qty !== 'undefined') {
      cnt = cnt * parseInt(bundle_qty);
    }

    if (!isPackagingBox && show_grouped_counter && !$checkbox.classList.contains('checked')) {
      if (typeof this.incrementGroupCounter === 'function') {
        this.incrementGroupCounter({ currentTarget: $checkbox });
      }
      return;
    }

    // checking if qty is a decimal
    let qtyElement = $produkt.querySelector('.qty span[data-qty]');
    let qty = qtyElement ? parseFloat(qtyElement.dataset.qty) : 0;

    if (qty % 1 !== 0 && !$checkbox.classList.contains('checked')) {
      Popup.create({
        content: intl.get('Czy na pewno spakowałeś {qty} {uom}?', {
          qty: qty,
          uom: product.uom_name
        }),
        buttons: {
          right: [
            {
              text: intl.get('Tak'),
              key: 'enter',
              action: () => {
                Popup.close();
                $checkbox.classList.toggle('checked');
                if (!$checkbox.classList.contains('mainCheckbox')) {
                  console.log('items collected');
                  this.bundleItemsCollected($produkt, parent);
                }
                parent.toggleConfirmButton();
              }
            },
            {
              text: intl.get('Nie'),
              className: 'cancel-button',
              action: () => {
                Popup.close();
              }
            }
          ]
        }
      });
      return;
    }

    const self = this;

    if (!isPackagingBox && verify_qty && cnt >= (group_treshold || 10) && !$checkbox.classList.contains('checked')) {
      if (show_grouped_counter) {
        const incrementButton = $produkt.querySelector('.grouped_counter__increment');
        if (incrementButton) {
          incrementButton.click();
        }
        return;
      }

      Popup.create({
        content: intl.get('Czy na pewno spakowałeś X pozycji tego SKU?', { cnt: cnt }),
        buttons: {
          right: [
            {
              text: intl.get('Tak'),
              key: 'enter',
              action: function() {
                Popup.close();
                $checkbox.classList.toggle('checked');
                if (
                  $produkt.querySelector('.bundleItemList') &&
                  $checkbox.classList.contains('mainCheckbox') &&
                  bundle_select
                ) {
                  const isChecked = $checkbox.classList.contains('checked');
                  self.updateBundleCheckboxesAndCounters($produkt, isChecked);
                  self.updateBundleCountersLive($produkt);
                } else if (!$checkbox.classList.contains('mainCheckbox')) {
                  console.log('items collected');
                  self.bundleItemsCollected($produkt, parent);
                }
                parent.toggleConfirmButton();
              }
            },
            {
              text: intl.get('Nie'),
              className: 'cancel-button',
              action: function() {
                Popup.close();
              }
            }
          ]
        }
      });
      return;
    } else {
      this.setState({ groupCounter: 0 });
      $checkbox.classList.toggle('checked');
    }

    if (
      $produkt.querySelector('.bundleItemList') &&
      event.currentTarget.classList.contains('mainCheckbox') &&
      bundle_select
    ) {
      const isChecked = $checkbox.classList.contains('checked');
      this.updateBundleCheckboxesAndCounters($produkt, isChecked);
      this.updateBundleCountersLive($produkt);
    }
    parent.toggleConfirmButton();
  };

  updateBundleCheckboxesAndCounters = ($produkt, isChecked) => {
    const $bundleList = $produkt.querySelector('.bundleItemList');
    if (!$bundleList) return;
    let elems = $bundleList.querySelectorAll('.checkbox');
    for (let i = 0; i < elems.length; ++i) {
      elems[i].classList.toggle('checked', isChecked);
    }

    const $counters = $bundleList.querySelectorAll('.counter');
    $counters.forEach($counter => {
      const fullQty = parseFloat($counter.dataset.destination) || 0;
      updateCounter($counter, isChecked ? fullQty : 0);
    });
  };

  updateBundleCountersLive = ($produkt) => {
    const bundleQty = parseInt($produkt.dataset.prods) || 1;

    const $bundleList = $produkt.querySelector('.bundleItemList');
    if (!$bundleList) return;

    const rows = $bundleList.querySelectorAll('tr');

    rows.forEach($row => {
      const checkbox = $row.querySelector('.checkbox');
      const counter = $row.querySelector('.counter');
      const qtyPerBundle = parseFloat($row.getAttribute('data-qty')) || 1;

      const currentQty = checkbox.classList.contains('checked') ? qtyPerBundle * bundleQty : 0;

      updateCounter(counter, currentQty);
    });
  }

  updateCountersFromGroupCounter = () => {
    const { product } = this.props;
    const { groupCounter } = this.state;

    if (!product.is_bundle || !product.items) return;

    const $produkt = document.querySelector(`.produkt[data-code="${product.default_code}"]`);
    if (!$produkt) return;

    const $bundleList = $produkt.querySelector('.bundleItemList');
    if (!$bundleList) return;

    const rows = $bundleList.querySelectorAll('.bundleItem');

    rows.forEach(($row, index) => {
      const item = product.items[index];
      if (!item) return;

      const $counter = $row.querySelector('.counter');
      if (!$counter) return;

      const currentQty = item.qty_uom * groupCounter;
      updateCounter($counter, currentQty);
    });
  }

  toggleConfirmButton = () => {
    const { parent } = this.props;
    if (parent && typeof parent.toggleConfirmButton === 'function') {
      parent.toggleConfirmButton();
    }
  };

  bundleItemsCollected = ($produkt, parent) => {
    const alldone = !$produkt.querySelector('.bundleItemList .checkbox:not(.checked)')
    $produkt.querySelector('.product_checkbox .checkbox').classList.toggle('checked', alldone)
    console.log($produkt.querySelector('.product_checkbox .checkbox').classList.toggle('checked', alldone))
  }

  nextImage = () => {
    const { product } = this.props;
    const { currentIndex } = this.state;
    const nextIndex = (currentIndex + 1) % product.additional_images.length;
    this.setState({ currentIndex: nextIndex });
  };

  prevImage = () => {
    const { product } = this.props;
    let { currentIndex } = this.state;
    const prevIndex = (currentIndex - 1 + product.additional_images.length) % product.additional_images.length;
    this.setState({ currentIndex: prevIndex });
  };

  render() {
    const { product, qty, supercount, stock_location, group_treshold, product_confirmation_method, productTracking, isLotTracking, order, show_grouped_counter, show_grouped_counter_check_all, show_barcode_in_packing_zone, show_line_option_in_packing_zone, bundleViewExtended, isPackagingBox } = this.props
    const { lots, selectedLot, groupCounter, currentIndex } = this.state
    const odoo = window.ODOO.url + (window.ODOO.port?':'+window.ODOO.port:'')+'/product/image?default_code='
    let className = 'ramka produkt'+
                    (supercount?' supercount':'')+
                    (show_grouped_counter?' show_grouped_counter':'')+
                    (product.red?' red':'')+
                    (product.is_bundle?' has_bundle':'')+
                    (product.show_as_dropshipping_product?' dropshipping_product':'')+
                    (productTracking && selectedLot[1] === '' ? ' blocked_by_serial' : '')+
                    (product.shortage?' shortage':'')
    let service = product.product_type === 'service'
    const barcodeString = '#' + (product.barcode || '') + '#' + 
      (product.additional_barcodes_ids || []).map(item => 
        typeof item === 'object' ? item.barcode : item
      ).join('#') + '#'
    const scanRequired = isScanRequiredForLine(this.props, product)
    return (
      <div className={className} data-prods={qty} data-barcode={barcodeString} data-scan-required={scanRequired ? '1' : '0'} data-name={b64EncodeUnicode(product.product_name || '')} data-code={product.default_code || ''}>
        <div>
          <div className="dropshipping_label">Dropshipping</div>
          <div className="scanned_icon_wrapper"><div/></div>
          { product.substitute_products && product.substitute_products.length > 0 &&
            <div className="substitutes">
              <div className={`substitutes__toggle ${product.line_qty ? 'active' : ''}`} onClick={() => {
                Popup.plugins().substitutes(
                  product.substitute_products,
                  this.setSubstitutes,
                  this.confirmSubstitutes,
                  this.resetSubstitutes,
                  typeof product.line_qty !== 'undefined' ? product.line_qty : qty,
                  order.note)
              }}/>
            </div>
          }
          <div className="image_holder">
              <Lightbox
                key={
                  product.move_line_id && product.move_line_id !== 0
                    ? `${product.line_id}_${product.move_line_id}`
                    : `${product.line_id}`
                }
              >
                 <img src={odoo+product.quote_default_code} alt="product"/>
              </Lightbox>
             {product.integration_offer_url &&
              <div className="center">
                <p><a href={product.integration_offer_url} target="_blank">{intl.get('URL Oferty')}</a></p>
              </div>
            }
           </div>
          {product.additional_images && product.additional_images.length > 0 && (
            <div className="additionalimages__container">
                <Lightbox key={currentIndex} style={{ display: 'block' }}>
                  <img src={`data:image/jpeg;base64, ${product.additional_images[currentIndex]}`} alt={`${product.product_name} - ${currentIndex + 1}`} />
                </Lightbox>
                {product.additional_images.length > 1 && (
                  <div className="navigation-buttons">
                    <button onClick={this.prevImage} className="prev-button">
                      &lt;
                    </button>
                    <button onClick={this.nextImage} className="next-button">
                      &gt;
                    </button>
                  </div>
                )}
            </div>
          )}

          <div className="product_details">
            <h4>
              {product.product_name}
              <span className='product_details__codes'>
                {product.default_code &&
                  <div className="default_code" data-code={product.default_code}><label>SKU:</label> [{product.default_code}]</div>
                }
                {show_barcode_in_packing_zone && product.barcode &&
                  <div className="product_details__barcode"><label>EAN:</label> [{product.barcode}]</div>
                }
              </span>
            </h4>
            { productTracking &&
              <>
                <div className="serial f_group">
                  <label>{intl.get('Partia / Numer seryjny')}:</label>
                  <div>
                    <Autosuggest
                      suggestions={lots || []}
                      onSuggestionsFetchRequested={this.onLotsFetchRequested}
                      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                      getSuggestionValue={(lot) => lot[0]}
                      renderSuggestion={(lot) => lot[1]}
                      shouldRenderSuggestions={() => true}
                      inputProps={{
                        value: selectedLot[1] || "",
                        onChange: this.handleLotChange,
                        name: `${product.move_line_id}`,
                        readOnly: isLotTracking,
                        disabled: isLotTracking,
                        className: isLotTracking ? 'readonly-lot' : ''
                      }}
                    />
                  </div>
                </div>
                <div className="serial_value"
                  data-sku={product.default_code}
                  data-is-serial={product.lots_serial ? 'true' : 'false'}
                  data-selected-lot={selectedLot[1]}
                  data-is-lot-tracking={isLotTracking ? 'true' : 'false'}
                  >
                  {JSON.stringify(selectedLot)}
                </div>
              </>
            }
            <div className="qty f_group">
              <label>{intl.get('Ilość')}:</label>
              <div><span data-qty={qty}>{qty}</span> {product.uom_name}</div>
            </div>
           {product.show_product_unit_prices &&
            <div className="price f_group">
              <label>{intl.get('Cena jednostkowa')}:</label>
              <div>{product.price_unit_gross}</div>
            </div>}
            {stock_location &&
              <div className="stock_location f_group f_group--block">
                <label>{intl.get('Strefa składowania')}:</label>
                <div className='' dangerouslySetInnerHTML={{__html: product.location.replaceAll(', ', ',<br/>')}}/>
              </div>
            }
            {show_line_option_in_packing_zone && product.product_option &&
              <div className="line_option f_group">
                <label>{intl.get('Opcja')}:</label>
                <div>{product.product_option}</div>
              </div>
            }
            {product.packing_zone_notes &&
              <div className="notes f_group">
                <label>{intl.get('Uwagi do pakowania')}:</label>
                <div>{product.packing_zone_notes}</div>
              </div>
            }

            {(show_grouped_counter && show_grouped_counter_check_all) &&
              <div className='grouped__mark-all'>
                <div className="checkbox custom"
                  onClick={this.modIncrementGroupCounter}
                  data-label={intl.get('Oznacz wszystko')}>
                  <Check className="check"/>
                </div>
              </div>
            }

          </div>
          {!service && !product.show_as_dropshipping_product &&
            <div className={`product_checkbox${['click', 'scan_click'].includes(product_confirmation_method) && !scanRequired?' clickable':''}`} data-line={product.line_id} data-product={product.product_id} data-prods={qty}>
              <div data-code-barcode={barcodeString} className="checkbox mainCheckbox" onClick={this.checkboxClick}>
                <Check className="check"/>
              </div>
              {show_grouped_counter && !isPackagingBox &&
                <div className='grouped_counter'>
                  <div className='grouped_counter_count' data-destination={qty} data-count={groupCounter}>
                    <span className='current-count'>{groupCounter}</span> / {qty}
                  </div>
                  <button className='grouped_counter__increment' onClick={this.incrementGroupCounter}/>
                </div>
              }
            </div>
          }
        </div>
        {
          product.is_bundle && (
            bundleViewExtended ? (
              <div className="bundleWrapper viewExtended">
                <BundleItemListExtended
                  product={product}
                  parent={this}
                  groupTreshold={group_treshold || 10}
                  toggleConfirmButton={this.toggleConfirmButton}
                  showBarcodeInPackingZone={show_barcode_in_packing_zone}
                  currentIndex={currentIndex}
                />
              </div>
            ) : (
              <div className="bundleWrapper">
                {printBundle(product, this, group_treshold || 10, this.toggleConfirmButton)}
              </div>
            )
          )
        }

      </div>
    )
  }
}

const ProductListItem = connect(mapStateToProps)(ProductListItemComponent)
export default ProductListItem